<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <section class="section is-main-section">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
      />
      <card-component
        class="has-table has-mobile-sort-spaced"
        title="Module"
        icon="calendar"
      >
        <refresh-button slot="button" />
        <card-toolbar slot="toolbar">
          <div
            slot="left"
            class="buttons has-addons"
          >
            <router-link
              :to="{name:'module.new'}"
              class="button is-primary"
            >
              Modul nou
            </router-link>
          </div>
        </card-toolbar>
        <modules-table-sample
          v-if="modules.length > 0"
          :modules="modules"
          @handleDeleteModule="handleDeleteModule"
        />
        <modules-table-sample
          v-else
          is-empty
        />
      </card-component>
    </section>
  </div>
</template>

<script>

import { reactive } from '@vue/composition-api'
import ModulesTableSample from '@/components/ModulesTableSample.vue'
import CardComponent from '@/components/CardComponent.vue'
import TitleBar from '@/components/TitleBar.vue'
import RefreshButton from '@/components/RefreshButton.vue'
import CardToolbar from '@/components/CardToolbar.vue'
import ModuleService from '@/services/modules.service'

export default {
  name: 'Modules',
  components: { CardToolbar, RefreshButton, TitleBar, CardComponent, ModulesTableSample },
  setup (props, { root: { $buefy } }) {
    const titleStack = ['Linguapro', 'Module']
    return {
      titleStack,
      modules: reactive([]),
      isLoading: false
    }
  },
  async created () {
    this.isLoading = true
    this.getAllModules().then((response) => {
      this.modules = response
      this.isLoading = false
    })
  },
  methods: {
    async getAllModules () {
      const { getModules } = ModuleService
      const response = await getModules()
      const { data } = response
      return data
    },
    async handleDeleteModule (id) {
      const { deleteModule } = ModuleService
      const response = await deleteModule(id)
      const { status } = response
      if (status === 200) {
        const index = this.modules.findIndex((prop) => prop.id === id)
        this.modules.splice(index, 1)
        this.$buefy.snackbar.open({
          message: 'Inregistrea a fost stearsa.',
          queue: false
        })
      } else {
        this.$buefy.snackbar.open({
          message: 'Eroare la stergerea inregistrarii.',
          queue: false
        })
      }
    }
  }
}
</script>
